/* eslint-disable react-hooks/exhaustive-deps */
/* ============================================================
   สร้าง / แก้ไขโปรเจ็กต์บ้าน   /support/project/manage/:code (new = สร้างใหม่)
============================================================ */
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  Table,
  Typography,
  message,
} from "antd";
import { DeleteOutlined, PlusOutlined, SaveFilled, UserAddOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { ButtonBack } from "../../../components/button";
import { PROJECT_STATUS } from "../../../components/ak/StatusTag";
import { CustomerService, EmployeeService, ProjectService, apiError } from "../../../service/Ak.service";
import { EmployeeFormFields, employeePayload } from "../../master/employee/EmployeePage";
import OptionService from "../../../service/Options.service";
import { usePermission } from "../../../store/context/permission-context";
import { CustomerFormFields } from "../customer/CustomerPage";
import { PROVINCE_OPTIONS } from "../../../utils/util";
import { Authenticate } from "../../../service/Authenticate.service";

const opt = OptionService();
const DATE_FIELDS = ["contract_date", "start_date", "end_date"];
const money = { formatter: (v) => (v === undefined || v === null || v === "" ? "" : `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), parser: (v) => `${v}`.replace(/,/g, "") };

export default function ProjectManage() {
  const { code } = useParams();
  const isNew = code === "new";
  const navigate = useNavigate();
  const { can } = usePermission();
  const [form] = Form.useForm();
  const [cusForm] = Form.useForm();
  const [loading, setLoading] = useState(!isNew);
  const [saving, setSaving] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [models, setModels] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [openEmp, setOpenEmp] = useState(false);
  const [empForm] = Form.useForm();
  const [roles, setRoles] = useState([]);
  const [team, setTeam] = useState([]);
  const [openCus, setOpenCus] = useState(false);

  const canSave = can("support_project", isNew ? "add" : "edit");
  const back = isNew ? "/support/project" : `/support/project/view/${code}`;

  const loadCustomers = () => opt.customers().then((r) => setCustomers(r.data?.data || []));
  const loadEmployees = () =>
    opt.employees().then((r) => {
      const list = r.data?.data || [];
      setEmployees(list);
      return list;
    });

  /* เพิ่มพนักงานใหม่จากในฟอร์ม (เช่น โฟร์แมนที่ไม่มี login) แล้วใส่เข้าทีมเลย */
  const saveEmployee = async () => {
    const v = await empForm.validateFields();
    try {
      const res = await EmployeeService.create(employeePayload(v));
      const e = res.data?.data;
      await loadEmployees();
      setTeam((p) => [...p, { key: Date.now(), emp_code: e.emp_code, team_role: v.team_role || "โฟร์แมน", is_lead: "N" }]);
      setOpenEmp(false);
      message.success(`เพิ่มพนักงาน ${e.firstname} เข้าทีมแล้ว`);
    } catch (err) {
      message.error(apiError(err, "เพิ่มพนักงานไม่สำเร็จ"));
    }
  };

  useEffect(() => {
    loadCustomers();
    opt.houseModels().then((r) => setModels(r.data?.data || []));
    const empReady = loadEmployees();
    opt.teamRoles().then((r) => setRoles(r.data?.data || []));

    if (isNew) {
      const me = String(Authenticate().getUserId?.() || "");
      form.setFieldsValue({ status: "ร่าง", plan_days: 365, site_province: "ระยอง" });
      /* คนที่สร้าง ถ้ามีข้อมูลพนักงานผูกกับ login อยู่ ใส่เป็น Support หลักให้ */
      empReady.then((list) => {
        const mine = list.find((e) => String(e.user_code || "") === me);
        if (mine) setTeam([{ key: 1, emp_code: mine.emp_code, team_role: "Support", is_lead: "Y" }]);
      });
      return;
    }
    ProjectService.get(code)
      .then((res) => {
        const p = res.data?.data || {};
        const v = { ...p };
        DATE_FIELDS.forEach((f) => (v[f] = p[f] ? dayjs(p[f]) : null));
        form.setFieldsValue(v);
        setTeam((p.team || []).map((t, i) => ({ key: i + 1, emp_code: t.emp_code, team_role: t.team_role, is_lead: t.is_lead })));
      })
      .catch((e) => message.error(apiError(e, "โหลดโปรเจ็กต์ไม่สำเร็จ")))
      .finally(() => setLoading(false));
  }, [code]);

  /* เลือกแบบบ้าน → เติมระยะเวลาก่อสร้าง / ชื่อโปรเจ็กต์ให้ ถ้ายังว่าง */
  const onModel = (mc) => {
    const m = models.find((x) => x.model_code === mc);
    if (!m) return;
    const cur = form.getFieldsValue();
    const patch = {};
    if (m.build_days) patch.plan_days = Number(m.build_days);
    if (!cur.contract_value && m.base_price) patch.contract_value = Number(m.base_price);
    form.setFieldsValue(patch);
  };
  const onCustomer = (cc) => {
    const c = customers.find((x) => x.cus_code === cc);
    if (c && !form.getFieldValue("project_name")) form.setFieldValue("project_name", `บ้าน${c.prename === "คุณ" ? "คุณ" : ""}${c.cus_name}`);
  };

  const start = Form.useWatch("start_date", form);
  const days = Form.useWatch("plan_days", form);
  const autoEnd = useMemo(() => (start && days ? dayjs(start).add(Number(days) - 1, "day") : null), [start, days]);

  const saveCustomer = async () => {
    const v = await cusForm.validateFields();
    try {
      const res = await CustomerService.create(v);
      const c = res.data?.data;
      await loadCustomers();
      form.setFieldValue("cus_code", c.cus_code);
      onCustomer(c.cus_code);
      if (!form.getFieldValue("project_name")) form.setFieldValue("project_name", `บ้าน${c.prename === "คุณ" ? "คุณ" : ""}${c.cus_name}`);
      setOpenCus(false);
      message.success(`เพิ่มลูกค้า ${c.cus_code} แล้ว`);
    } catch (e) {
      message.error(apiError(e, "เพิ่มลูกค้าไม่สำเร็จ"));
    }
  };

  const save = async () => {
    const v = await form.validateFields();
    const header = { ...v, project_code: isNew ? undefined : code };
    DATE_FIELDS.forEach((f) => (header[f] = v[f] ? dayjs(v[f]).format("YYYY-MM-DD") : null));
    setSaving(true);
    try {
      const res = await (isNew ? ProjectService.create({ header, team }) : ProjectService.update({ header, team }));
      message.success("บันทึกโปรเจ็กต์เรียบร้อย");
      navigate(`/support/project/view/${res.data?.data?.project_code || code}`, { replace: true });
    } catch (e) {
      message.error(apiError(e, "บันทึกไม่สำเร็จ"));
    } finally {
      setSaving(false);
    }
  };

  const setT = (key, patch) => setTeam((p) => p.map((t) => (t.key === key ? { ...t, ...patch } : t)));
  const teamCols = [
    {
      title: "พนักงาน",
      dataIndex: "emp_code",
      render: (v, r) => (
        <Select
          value={v}
          onChange={(x) => {
            const e = employees.find((y) => y.emp_code === x);
            /* ตำแหน่งงานตรงกับหน้าที่ในทีม → ตั้งหน้าที่ให้ */
            const role = roles.find((ro) => ro.value === e?.position)?.value;
            setT(r.key, { emp_code: x, ...(role ? { team_role: role } : {}) });
          }}
          options={employees}
          showSearch
          optionFilterProp="label"
          placeholder="เลือกพนักงาน"
          style={{ width: "100%", minWidth: 260 }}
        />
      ),
    },
    {
      title: "หน้าที่ในโปรเจ็กต์",
      dataIndex: "team_role",
      width: 220,
      render: (v, r) => <Select value={v} onChange={(x) => setT(r.key, { team_role: x })} options={roles} style={{ width: "100%" }} />,
    },
    {
      title: "ผู้รับผิดชอบหลัก",
      dataIndex: "is_lead",
      width: 130,
      align: "center",
      render: (v, r) => <Switch checked={v === "Y"} onChange={(c) => setT(r.key, { is_lead: c ? "Y" : "N" })} />,
    },
    { title: "", key: "x", width: 50, render: (_, r) => <Button type="text" danger icon={<DeleteOutlined />} onClick={() => setTeam((p) => p.filter((t) => t.key !== r.key))} /> },
  ];

  if (loading) return <Flex justify="center" style={{ padding: 80 }}><Spin /></Flex>;

  return (
    <div>
      <Flex justify="space-between" align="center" className="mb-3" wrap="wrap" gap={8}>
        <Typography.Title level={3} className="m-0 !text-zinc-800">
          {isNew ? "สร้างโปรเจ็กต์บ้าน" : `แก้ไขโปรเจ็กต์ ${code}`}
        </Typography.Title>
        <Space>
          <ButtonBack target={back} />
          {canSave && (
            <Button type="primary" icon={<SaveFilled />} loading={saving} onClick={save}>
              บันทึก
            </Button>
          )}
        </Space>
      </Flex>

      <Form form={form} layout="vertical" disabled={!canSave} autoComplete="off">
        <Card className="ak-card mb-3" title="ลูกค้า และแบบบ้าน">
          <Row gutter={12}>
            <Col xs={24} md={10}>
              <Form.Item label="ลูกค้า" required>
                <Space.Compact style={{ width: "100%" }}>
                  <Form.Item name="cus_code" noStyle rules={[{ required: true, message: "เลือกลูกค้า" }]}>
                    <Select options={customers} showSearch optionFilterProp="label" placeholder="ค้นหาชื่อ / เบอร์" onChange={onCustomer} style={{ width: "100%" }} />
                  </Form.Item>
                  {can("support_customer", "add") && (
                    <Button icon={<UserAddOutlined />} onClick={() => { cusForm.resetFields(); cusForm.setFieldsValue({ prename: "คุณ", province: "ระยอง" }); setOpenCus(true); }}>
                      ลูกค้าใหม่
                    </Button>
                  )}
                </Space.Compact>
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item name="model_code" label="แบบบ้าน">
                <Select allowClear options={models} showSearch optionFilterProp="label" onChange={onModel} placeholder="เลือกแบบบ้าน" />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="status" label="สถานะ">
                <Select options={PROJECT_STATUS.map((s) => ({ value: s, label: s }))} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="project_name" label="ชื่อโปรเจ็กต์" rules={[{ required: true, message: "กรอกชื่อโปรเจ็กต์" }]}>
                <Input maxLength={200} placeholder="เช่น บ้านคุณสมชาย (AK-101)" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card className="ak-card mb-3" title="ที่ดินที่ปลูกสร้าง">
          <Row gutter={12}>
            <Col span={24}>
              <Form.Item name="site_address" label="ที่ตั้ง (เลขที่ / หมู่ / ถนน / หมู่บ้าน)">
                <Input maxLength={255} />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="site_subdistrict" label="ตำบล">
                <Input maxLength={100} />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="site_district" label="อำเภอ">
                <Input maxLength={100} />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="site_province" label="จังหวัด">
                <Select allowClear showSearch options={PROVINCE_OPTIONS} />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="site_zipcode" label="รหัสไปรษณีย์">
                <Input maxLength={10} />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="land_deed_no" label="เลขที่โฉนด">
                <Input maxLength={100} />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="land_area" label="ขนาดที่ดิน">
                <Input maxLength={100} placeholder="เช่น 1 งาน 20 ตร.ว." />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="map_url" label="ลิงก์ Google Maps" rules={[{ pattern: /^https?:\/\//i, message: "ต้องขึ้นต้นด้วย http:// หรือ https://" }]}>
                <Input maxLength={500} placeholder="https://maps.app.goo.gl/..." />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card className="ak-card mb-3" title="สัญญา และแผนงาน">
          <Row gutter={12}>
            <Col xs={24} md={6}>
              <Form.Item name="contract_no" label="เลขที่สัญญา">
                <Input maxLength={50} />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="contract_date" label="วันที่ทำสัญญา">
                <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="contract_value" label="มูลค่าสัญญา (บาท)">
                <InputNumber min={0} style={{ width: "100%" }} {...money} />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="plan_days" label="แผนงาน">
                <Select options={[{ value: 365, label: "365 วัน" }, { value: 450, label: "450 วัน" }, { value: 540, label: "540 วัน" }]} />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="start_date" label="วันเริ่มงาน">
                <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="end_date" label="วันสิ้นสุดตามแผน" extra={autoEnd ? `ว่างไว้ = ${autoEnd.format("DD/MM/YYYY")} อัตโนมัติ` : null}>
                <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="remark" label="หมายเหตุ" className="!mb-0">
                <Input.TextArea rows={3} maxLength={4000} />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Form>

      <Card
        className="ak-card mb-3"
        title="ทีมผู้รับผิดชอบ"
        extra={
          canSave && (
            <Space>
              {can("master_employee", "add") && (
                <Button icon={<UserAddOutlined />} onClick={() => { empForm.resetFields(); empForm.setFieldsValue({ department: "ก่อสร้าง", position: "โฟร์แมน", team_role: "โฟร์แมน" }); setOpenEmp(true); }}>
                  พนักงานใหม่
                </Button>
              )}
              <Button icon={<PlusOutlined />} onClick={() => setTeam((p) => [...p, { key: Date.now(), emp_code: null, team_role: "Support", is_lead: "N" }])}>
                เพิ่มคน
              </Button>
            </Space>
          )
        }
      >
        <Table size="small" rowKey="key" pagination={false} columns={teamCols} dataSource={team} locale={{ emptyText: "ยังไม่มีทีม — เพิ่มพนักงานที่รับผิดชอบ (ไม่จำเป็นต้องมี login)" }} />
      </Card>

      {canSave && (
        <Flex justify="end" gap={8}>
          <ButtonBack target={back} />
          <Button type="primary" icon={<SaveFilled />} loading={saving} onClick={save}>
            บันทึก
          </Button>
        </Flex>
      )}

      <Modal open={openCus} title="เพิ่มลูกค้าใหม่" onCancel={() => setOpenCus(false)} onOk={saveCustomer} okText="บันทึกลูกค้า" cancelText="ยกเลิก" width={720} forceRender>
        <Form form={cusForm} layout="vertical" autoComplete="off">
          <CustomerFormFields />
        </Form>
      </Modal>

      <Modal open={openEmp} title="เพิ่มพนักงานใหม่ (ไม่ต้องมี login)" onCancel={() => setOpenEmp(false)} onOk={saveEmployee} okText="บันทึกและใส่เข้าทีม" cancelText="ยกเลิก" width={820} forceRender>
        <Form form={empForm} layout="vertical" autoComplete="off">
          <EmployeeFormFields withLogin={false} />
          <Form.Item name="team_role" label="หน้าที่ในโปรเจ็กต์นี้">
            <Select options={roles} style={{ maxWidth: 260 }} />
          </Form.Item>
        </Form>
      </Modal>

      <Divider className="!my-2" />
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        สถานะ "ทำสัญญาแล้ว" ขึ้นไปต้องมีวันที่ทำสัญญา
      </Typography.Text>
    </div>
  );
}
